<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            fixed
            prop="username"
            label="管理员名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="registerTime"
            label="创建时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="roleList[0].roleName"
            label="管理员角色"
            width="180">
    </el-table-column>
    <el-table-column
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "AdminTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$emit("view",id)
      },
      update(id){
        this.$emit("update",id)
      },
      del(id){
        this.$emit("del",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
